"use client";
import {
  GoogleMap,
  Marker,
  MarkerClusterer,
  useLoadScript,
  InfoWindow,
} from "@react-google-maps/api";
import { useMemo } from "react";

const option = {
  zoomControl: true,
  disableDefaultUI: true,
  styles: [/* 你的 styles 原封不動 */],
  scrollwheel: true,
};
const containerStyle = { width: "100%", height: "100%" };

// 👇 預設 visible = false → 不顯示地圖，但保留元件與邏輯
export default function StoreMap({
  storesLocations = [],
  getLocation,
  setLocation,
  visible = false,
}) {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyAAz77U5XQuEME6TpftaMdX0bBelQxXRlM",
  });

  // 清洗座標，避免 NaN / undefined
  const safeLocations = useMemo(
    () =>
      Array.isArray(storesLocations)
        ? storesLocations.filter(
            (l) => Number.isFinite(l?.lat) && Number.isFinite(l?.lng)
          )
        : [],
    [storesLocations]
  );

  const center = useMemo(() => {
    if (!safeLocations.length) {
      // 給個安全預設中心（之後要開地圖才用得到）
      return { lat: 25.033964, lng: 121.564468 }; // Taipei 101 附近
    }
    const num = safeLocations.length;
    const sumLat = safeLocations.reduce((s, l) => s + l.lat, 0);
    const sumLng = safeLocations.reduce((s, l) => s + l.lng, 0);
    return { lat: sumLat / num, lng: sumLng / num };
  }, [safeLocations]);

  const locationHandler = (location) => setLocation?.(location);
  const closeCardHandler = () => setLocation?.(null);

  // 🚫 先不要顯示：直接不渲染任何地圖相關 DOM
  if (!visible) return null;

  if (!isLoaded) return null;

  const hasLocation =
    getLocation &&
    Number.isFinite(getLocation.lat) &&
    Number.isFinite(getLocation.lng);

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={3}
      options={option}
    >
      <MarkerClusterer>
        {(clusterer) =>
          safeLocations.map((marker) => (
            <Marker
              key={marker.id}
              position={{ lat: marker.lat, lng: marker.lng }}
              clusterer={clusterer}
              onClick={() => locationHandler(marker)}
            />
          ))
        }
      </MarkerClusterer>

      {hasLocation && (
        <InfoWindow
          position={{ lat: getLocation.lat, lng: getLocation.lng }}
          onCloseClick={closeCardHandler}
        >
          <div className="google-map__marker-detail ">
            <div className="google-map__marker-detail__content">
              <h5>Store in {getLocation.city}</h5>
              <p>
                {getLocation.address}
                <br />
                {getLocation.country}
                <br />
                {getLocation.phone}
                <br />
                {getLocation.hours}
              </p>
            </div>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
}
